import PropTypes from 'prop-types';
import { Box, Tooltip, Typography } from '@mui/material';
import {
    tableCellInnerBoxStyle,
} from '../../../../styles/NewLeadTableRowStyle';

const EmailField = ({ rowData }) => (
    <Tooltip title={`${rowData?.email}`}>
        <Box sx={{ ...tableCellInnerBoxStyle, justifyContent: 'flex-start' }}>
            <Typography variant='body2' noWrap>{rowData?.email || ''}</Typography>
        </Box>
    </Tooltip>
);

EmailField.propTypes = {
    rowData: PropTypes.any,
};

export default EmailField;
